import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  fetchSMSTemplate,
  createSMSTemplate,
  deleteSMSTemplate,
  updateSMSTemplate,
  createTestSMS
} from "../actions/index";
import SMSTemplatesForm from "./SMSTemplatesForm";
import { CSSTransitionGroup } from 'react-transition-group';
import { Modal } from "react-bootstrap";
import { toastr } from "react-redux-toastr";

class SMSTemplatesEditInline extends Component {
  static propTypes = {
    fetchSMSTemplate: PropTypes.func.isRequired,
    createSMSTemplate: PropTypes.func.isRequired,
    deleteSMSTemplate: PropTypes.func.isRequired,
    updateSMSTemplate: PropTypes.func.isRequired,
    handleUpdateSMSId: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    smsTemplate: PropTypes.object,
    sms_template_id: PropTypes.number,
    id: PropTypes.number,
    createTestSMS: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      showModal: false,
      duplicateName: ""
    };
  }

  componentDidMount() {
    this.props.fetchSMSTemplate( this.props.sms_template_id );
  }

  sendTestSMS(state) {
    this.props
      .createTestSMS(state)
      .then(response => {
        if (response.payload.status == 200) {
          toastr.success("Test SMS Sent!");
        }
      });
  }

  onUpdateEverywhereConfirmation(state) {
    this.setState({
      formData: {
        body_text: state.body_text,
        sms_template_category_id: state.sms_template_category_id,
        name: state.name
      }
    });
    const msg =
      "Warning: This sms template is used in more than one place. Would you like to change it everywhere or just here?";
    const toastrConfirmOptions = {
      okText: "Update Everywhere",
      cancelText: "Update Current",
      onOk: () => this.updateSMSTemplate(state),
      onCancel: () => this.copySMSTemplate(state)
    };
    toastr.confirm(msg, toastrConfirmOptions);
  }

  copySMSTemplate(state) {
    this.openModal();
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  openModal() {
    this.setState({ showModal: true });
  }

  onSubmitCopy(state) {
    let data = Object.assign(this.state.formData, {
      name: this.state.duplicateName
    });
    this.props
      .createSMSTemplate(data)
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("SMS Template created!");
          this.props.fetchSMSTemplate(
            this.props.sms_template_id
          );
          this.props.handleUpdateSMSId(response.payload.data.data.id);
        }
      });
  }

  handleChangeDuplicateName(e) {
    const name = e.target.value;
    this.setState({ duplicateName: name });
  }


  onSubmit(state) {
    if (this.props. smsTemplate.data.campaigns_using.length > 1) {
      this.onUpdateEverywhereConfirmation(state);
    } else {
      this.updateSMSTemplate(state);
    }

  }

  updateSMSTemplate(state) {
    this.props
      .updateSMSTemplate(
        this.props.sms_template_id,
        state
      )
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("SMS Template saved!");
          this.props.fetchSMSTemplate(
            this.props.sms_template_id
          );
          this.props.handleUpdateSMSId(response.payload.data.data.id);
        }
      });
  }

  render() {
    const { smsTemplate } = this.props;
    if (!smsTemplate || !smsTemplate.data) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }

    return (
      <div className="m-b-40">
        <SMSTemplatesForm
          key={smsTemplate.data.id}
          handleSubmit={this.onSubmit.bind(this)}
          mode="edit"
          categories={smsTemplate.data.categories}
          videoTemplates={smsTemplate.data.video_templates}
          handleSendTestSMS={this.sendTestSMS.bind(this)}
          sms_template_category_id={smsTemplate.data.sms_template_category_id}
          match={this.props.match}
          name={smsTemplate.data.name}
          body_text={smsTemplate.data.body_text}
        />

        <Modal
          show={this.state.showModal}
          onHide={this.closeModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={true}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">
              New SMS Template
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className={`form-group ${
                name.touched && name.invalid ? "has-error" : ""
              }`}
            >
              <label>Name</label>
              <input
                type="text"
                className="form-control name_field"
                onChange={this.handleChangeDuplicateName.bind(this)}
                value={this.state.duplicateName}
              />
              <div className="help-block">{name.touched ? name.error : ""}</div>
            </div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.onSubmitCopy.bind(this)}
            >
              Save
            </button>
          </Modal.Body>
        </Modal>

      </div>
    );
  }
}

function mapStateToProps(state) {
  return { smsTemplate: state.smsTemplates.smsTemplate };
}

export default connect(
  mapStateToProps,
  { fetchSMSTemplate, createSMSTemplate, updateSMSTemplate, deleteSMSTemplate, createTestSMS }
)(SMSTemplatesEditInline);
